import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip
} from '@mui/material'
import {
  School as SchoolIcon,
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material'

const NativeAd = ({ type = 'course', position = 'sidebar' }) => {
  // Eğitim temalı örnek reklamlar
  const sampleAds = {
    course: {
      title: "🎯 IELTS Hazırlık Kursu",
      description: "Online IELTS kursuyla hedef puanına ulaş! Uzman eğitmenler, kapsamlı materyaller.",
      cta: "Ücretsiz Dene",
      badge: "Sponsorlu",
      color: "primary"
    },
    book: {
      title: "📚 İngilizce Kelime Kitabı",
      description: "3000 kelime, örnekler ve testlerle İngilizce kelime hazinenizi geliştirin.",
      cta: "Satın Al",
      badge: "Reklam",
      color: "secondary"
    },
    app: {
      title: "📱 Grammar Perfect App",
      description: "İngilizce gramer kurallarını oyunlarla öğren. iOS ve Android'de ücretsiz!",
      cta: "İndir",
      badge: "Sponsorlu",
      color: "success"
    }
  }

  const ad = sampleAds[type] || sampleAds.course

  const handleAdClick = () => {
    // Reklam tıklama analitikleri
    console.log('Reklam tıklandı:', type)
    // Google Analytics event tracking
    if (window.gtag) {
      window.gtag('event', 'ad_click', {
        event_category: 'advertisement',
        event_label: type,
        value: 1
      })
    }
  }

  return (
    <Card sx={{ 
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
      mb: 2,
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)'
      }
    }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <SchoolIcon color={ad.color} sx={{ mr: 1 }} />
          <Chip 
            label={ad.badge} 
            size="small" 
            variant="outlined" 
            sx={{ 
              fontSize: '0.7rem',
              color: 'text.secondary',
              borderColor: 'rgba(0, 0, 0, 0.2)'
            }} 
          />
        </Box>
        
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, fontSize: '1rem' }}>
          {ad.title}
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: '0.85rem' }}>
          {ad.description}
        </Typography>
        
        <Button 
          fullWidth 
          variant="contained" 
          color={ad.color}
          size="small"
          onClick={handleAdClick}
          startIcon={<TrendingUpIcon />}
          sx={{ 
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '0.85rem'
          }}
        >
          {ad.cta}
        </Button>
      </CardContent>
    </Card>
  )
}

export default NativeAd
